import {
    SCENE_TEMPLATES,
    TEMPLATE_RADIUS_CONSTANTS,
} from "@/lib/utils/lomda/constants";
import { DEFAULT_LOMDA_TEMPLATE } from "@/lib/utils/lomda/constants";
import { SceneTemplateVariation, LomdaScene } from "@/lib/utils/lomda/types";

export const getTemplateConfig = (selectedScene: LomdaScene | null) => {
    if (!selectedScene) {
        return null;
    }
    const templateVariation: SceneTemplateVariation =
        selectedScene?.template ?? DEFAULT_LOMDA_TEMPLATE;
    const templateConfig = SCENE_TEMPLATES[templateVariation];
    return { selectedScene, templateConfig };
};

export const calcA4Width = (h: number) => {
    return h / 1.414 / 1.777;
};

export const calcBorderRadius = (w: number, h: number) => {
    const rH = TEMPLATE_RADIUS_CONSTANTS.V / (h / 100);
    const rW = TEMPLATE_RADIUS_CONSTANTS.H / (w / 100);
    return `${rW.toFixed(2)}% / ${rH.toFixed(2)}%`;
};
